import { render, staticRenderFns } from "./collegeRuleEdit.vue?vue&type=template&id=33dc8a6c&scoped=true&"
import script from "./collegeRuleEdit.vue?vue&type=script&lang=js&"
export * from "./collegeRuleEdit.vue?vue&type=script&lang=js&"
import style0 from "./collegeRuleEdit.vue?vue&type=style&index=0&id=33dc8a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc8a6c",
  null
  
)

export default component.exports